import { render, staticRenderFns } from "./MasterPromoMobile.vue?vue&type=template&id=46f0d6c4&"
import script from "./MasterPromoMobile.vue?vue&type=script&lang=js&"
export * from "./MasterPromoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports